import { mapActions, mapState } from 'vuex';

import funcoes from "../../../util/funcoes.js";

import AppUploadArquivoDialog from "../../../shared/dialogs/UploadArquivoDialog.vue";
import { BANCOS_HOMOLOGADOS, TIPO_RETORNO } from "../../../util/constantes";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUniversity } from '@fortawesome/free-solid-svg-icons';

library.add(faUniversity)

export default {
    components: {
        AppUploadArquivoDialog,
        FontAwesomeIcon
    },
    data() {
        return {
            // ALUGUEIS
            arquivoRetorno: {
                nomeArquivo: undefined,
                banco: undefined,
                tipoRetorno: 'COBRANCA'
            },

            historicoRetorno: {
                pagina: 0,
                dataProcessamentoInicio: funcoes.primeiroDiaMes(),
                dataProcessamentoFim: funcoes.ultimoDiaMes(),
                nomeBanco: undefined
            },

            // GERAL
            tabSelecionada: 'alugueis',

            isLoadingImportar: false
        }
    },
    computed: {
        ...mapState('baixasStore', {
            recibosRetorno(state) { return state.recibosRetorno },
            historicoRetornos(state) { return state.historicoRetornos },
        }),
        bancos() {
            return BANCOS_HOMOLOGADOS
        },

        tiposRetorno() {
            return TIPO_RETORNO
        },

        classFieldIsActiveArquivo() {
            return this.tabSelecionada == 'alugueis' ? 'field-is-active' : ''
        },

        classFieldIsActiveHistorico() {
            return this.tabSelecionada == 'historicoBaixas' ? 'field-is-active' : ''
        },
        
        isPagamentosHomologado() {
            return this.arquivoRetorno.banco !== 'INTER'
        }
    },
    methods: {
        ...mapActions([
            'showLoading',
            'hideLoading'
        ]),
        ...mapActions('baixasStore', [
            'processarRetorno',
            'listarHistoricoRetorno',
            'limparRecibosRetorno'
        ]),
        selecionarArquivoHandler() {
            this.limparRecibosRetorno();

            if(this.$refs.upload.uploadFiles.length === 1) {
                this.$refs.upload.clearFiles();
            }
        },
        processarRetornoHandler() {
            this.isLoadingImportar = true;
            this.arquivoRetorno.nomeArquivo = this.$refs.upload.uploadFiles[0].name
            this.arquivoRetorno.arquivo = this.$refs.upload.uploadFiles[0].raw

            let payload = new FormData();
            payload.append("arquivo", this.$refs.upload.uploadFiles[0].raw);
            payload.append("nomeArquivo", this.$refs.upload.uploadFiles[0].name);
            payload.append("banco", this.arquivoRetorno.banco);
            payload.append("tipoRetorno", this.arquivoRetorno.tipoRetorno);

            this.processarRetorno(payload)
              .then((resultado) => {
                this.hideLoading()
                switch(resultado.status) {
                    case 'FALHA':
                        this.$message.warning(resultado.mensagem);
                        this.isLoadingImportar = false
                        break;
                    case 'SUCESSO':
                        window.open(resultado.mensagem, '_blank');
                        this.isLoadingImportar = false
                }

              })
              .catch(() => {
                this.hideLoading()
                this.limparCampos();
                this.$message.error("Não foi possível conectar-se ao servidor");
                this.isLoadingImportar = false
              });
        },

        historicoRetornoHandler() {
            this.showLoading()

            this.listarHistoricoRetorno(this.historicoRetorno)
              .then(() => {
                this.hideLoading()
                this.limparCampos();
              })
              .catch(() => {
                this.hideLoading()
                this.limparCampos();
                this.$message.error("Não foi possível conectar-se ao servidor");
              });
        },

        // UTIL
        getLabelBanco(item) {
            return funcoes.getLabel(this.bancos,item.nomeBanco)
        },
        getAluguel(item) {
            if(!item.recibo && !item.boletoAvulso) return ''
            return item.recibo ? item.recibo.aluguel.idNaImobiliaria : item.boletoAvulso.aluguel.idNaImobiliaria
        },
        getNome(item) {
            if(!item.recibo && !item.boletoAvulso) return ''
            return item.recibo ? item.recibo.cliente.nome : item.boletoAvulso.cliente.nome
        },
        getDataVencimento(item) {
            if(!item.recibo && !item.boletoAvulso) return ''
            return item.recibo ? item.recibo.dataVencimento : item.boletoAvulso.dataVencimento
        },
        getValor(item) {
            if(!item.recibo && !item.boletoAvulso) return ''
            return item.recibo ? item.recibo.valor : item.boletoAvulso.valor
        },
        limparCampos() {
            this.arquivoRetorno = {
                nomeArquivo: undefined,
                banco: undefined,
                tipoRetorno: 'COBRANCA'
            }
        },

        formatarValor(item) {
            return funcoes.formatarValor(item)
          },

        changeDetailsTableRow(arquivoRetorno) {
            return arquivoRetorno.recibo == null && arquivoRetorno.boletoAvulso == null
        },

        stateRowTable(arquivoRetorno) {
            let stateRow = { titleIcon: '',title: '', colorIcon: '' }

            if(arquivoRetorno.tipo == 'ERRO') {
                stateRow = { titleIcon: 'el-icon-error', title: 'Erro ao processar', colorIcon: '#DF1B1B' }
                return stateRow
            } else if(arquivoRetorno.recibo == null && arquivoRetorno.boletoAvulso == null && (arquivoRetorno.lancamento && arquivoRetorno.lancamento.id > 0)) {
                stateRow = { titleIcon: 'el-icon-document-delete', title: 'Lançamento de contas a receber', colorIcon: '#FF9E29'  }
                return stateRow;
            } else if(arquivoRetorno.recibo == null && arquivoRetorno.boletoAvulso == null) {
                stateRow = { titleIcon: 'el-icon-document-delete', title: `${this.arquivoRetorno.tipoRetorno === 'COBRANCA' ? 'Recibo' : 'Repasse' } não encontrado`, colorIcon: '#DF1B1B'  }
                return stateRow;
            } else if(arquivoRetorno.recibo && (arquivoRetorno.recibo.id > 0 && arquivoRetorno.boletoAvulso == null)) {
                if(arquivoRetorno.tipo == 'REGISTRO' && arquivoRetorno.mensagemResultado.includes('Registrado Previamente')) {
                    stateRow = { titleIcon: 'el-icon-document-checked', title: `${this.arquivoRetorno.tipoRetorno === 'COBRANCA' ? 'Recibo' : 'Repasse' } registrado previamente`, colorIcon: '#FF9E29' }
                    return stateRow
                } else if(arquivoRetorno.tipo == 'REGISTRO' && arquivoRetorno.mensagemResultado.includes('Registrado com sucesso')) {
                    stateRow = { titleIcon: 'el-icon-document-checked', title: `${this.arquivoRetorno.tipoRetorno === 'COBRANCA' ? 'Recibo' : 'Repasse' } registrado com sucesso`, colorIcon: '#2DB748' }
                    return stateRow
                } else if(arquivoRetorno.tipo == 'PAGO' && arquivoRetorno.mensagemResultado.includes('efetuado previamente')) {
                    stateRow = { titleIcon: 'el-icon-success', title: `${this.arquivoRetorno.tipoRetorno === 'COBRANCA' ? 'Recibo' : 'Repasse' } pago previamente`, colorIcon: '#FF9E29' }
                    return stateRow
                } else if(arquivoRetorno.tipo == 'PAGO' && arquivoRetorno.mensagemResultado.includes('efetuado com sucesso')) {
                    stateRow = { titleIcon: 'el-icon-success', title: `${this.arquivoRetorno.tipoRetorno === 'COBRANCA' ? 'Recibo' : 'Repasse' } pago com sucesso`, colorIcon: '#2DB748' }
                    return stateRow
                } else if(arquivoRetorno.tipo == 'PAGO' && arquivoRetorno.mensagemResultado.includes('Inconsistência')) {
                    stateRow = { titleIcon: 'el-icon-error', title: 'Inconsistência no valor de pagamento', colorIcon: '#DF1B1B' }
                    return stateRow
                }
            } else if(arquivoRetorno.boletoAvulso && (arquivoRetorno.recibo == null && arquivoRetorno.boletoAvulso.id > 0)) {
                if(arquivoRetorno.tipo == 'REGISTRO' && arquivoRetorno.mensagemResultado.includes('Registrado Previamente')) {
                    stateRow = { titleIcon: 'el-icon-document-checked', title: 'Boleto Avulso registrado previamente', colorIcon: '#FF9E29' }
                    return stateRow
                } else if(arquivoRetorno.tipo == 'REGISTRO' && arquivoRetorno.mensagemResultado.includes('Registrado com sucesso')) {
                    stateRow = { titleIcon: 'el-icon-document-checked', title: 'Boleto Avulso registrado com sucesso', colorIcon: '#2DB748' }
                    return stateRow
                } else if(arquivoRetorno.tipo == 'PAGO' && arquivoRetorno.mensagemResultado.includes('efetuado previamente')) {
                    stateRow = { titleIcon: 'el-icon-success', title: 'Boleto Avulso pago previamente', colorIcon: '#FF9E29' }
                    return stateRow
                } else if(arquivoRetorno.tipo == 'PAGO' && arquivoRetorno.mensagemResultado.includes('efetuado com sucesso')) {
                    stateRow = { titleIcon: 'el-icon-success', title: 'Boleto Avulso pago com sucesso', colorIcon: '#2DB748' }
                    return stateRow
                } else if(arquivoRetorno.tipo == 'PAGO' && arquivoRetorno.mensagemResultado.includes('Inconsistência')) {
                    stateRow = { titleIcon: 'el-icon-error', title: 'Inconsistência no valor de pagamento', colorIcon: '#DF1B1B' }
                    return stateRow
                }
            } else {
                return stateRow;
            }
        },

        messageRow(arquivoRetorno) {
            if(arquivoRetorno.mensagemResultado.includes('Pagamento efetuado com boletos anteriores em aberto') && !arquivoRetorno.mensagemResultado.includes('Inconsistência')) {
                return 'Pagamento efetuado com boletos anteriores em aberto.'
            } else if(arquivoRetorno.tipo == 'ERRO') {
                return arquivoRetorno.mensagemResultado
            } else {
                return '';
            }
        }
    }
}